import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "service-wrap" }
const _hoisted_2 = { class: "product-list" }
const _hoisted_3 = { class: "first-level-title" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "secondary-title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "product-box" }
const _hoisted_9 = { class: "product-introduction" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "product-img" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "product-text" }
const _hoisted_14 = { class: "product-title" }

import { ref, onMounted } from 'vue'
import { getProductTypes, getProductProfile, getProducts, getProductList } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import BannerC from '@/components/BannerC.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductServices',
  setup(__props) {

const router = useRouter()
const store = useStore()

const productTypes: any = ref({})
const activeType = ref(1)
const activeProduct = ref(0)
const products: any = ref([])


const selectType = (id: number) => {
  activeType.value = id;
  getProductsData(id)
}

const selectProduct = (id: number) => {
  activeProduct.value = id
  getProductsData(activeType.value, id)
}

const toOtherPath = (url: string, titleIndex: number, pageTitle: any) => {
  router.push(url);
  store.state.titleIndex = titleIndex;
  store.state.pageTitle = [...pageTitle]
}

onMounted(() => {
  const productCategory = window.localStorage.getItem('product-category');
  const brand = window.localStorage.getItem('brand')
  getProductTypes().then((res: any) => {
    getProductProfile().then((res2: any) => {
      // activeProduct.value = res2[0].brandProfileList[0].id
      res2.forEach((ele: any) => {
        if (!productTypes.value[ele.productTypeId]) {
          productTypes.value[ele.productTypeId] = { name: res[ele.productTypeId], value: [...(ele.brandProfileList || [])] }
        } else {
          productTypes.value[ele.productTypeId].push({ name: res[ele.productTypeId], value: [...(ele.brandProfileList || [])] })
        }
      });


      if (productCategory) {
        Object.keys(productTypes.value).forEach((e) => {
          if (productTypes.value[e].name == productCategory) {
            activeType.value = +e;
            if (brand) {
              productTypes.value[e].value.forEach((e: any) => {
                if (e.brandName == brand) {
                  activeProduct.value = e.id
                }
              })
            }
          }
        })

        window.localStorage.setItem('product-category', '')
        window.localStorage.setItem('brand', '')
      }
      getProductsData(activeType.value, activeProduct.value)
    })
  })
})

const getProductsData = (productTypeId?: number | string, brandId?: number | string) => {
  getProducts({ productTypeId, brandId }).then((res: any) => {
    products.value = { ...res.records }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BannerC),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productTypes.value, (item, id) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(activeType.value == id ? 'active' : ''),
            key: id,
            onClick: ($event: any) => (selectType(id))
          }, _toDisplayString(item.name), 11, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (productTypes.value[activeType.value]?.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productTypes.value[activeType.value].value, (item, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: _normalizeClass(activeProduct.value == item.id ? 'active' : ''),
                  key: index,
                  onClick: ($event: any) => (selectProduct(item.id))
                }, _toDisplayString(item.brandName), 11, _hoisted_7))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (e, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "product-info",
              key: i,
              onClick: ($event: any) => (toOtherPath(`/product_detail?id=${e.id}&pathName=数智产品,${e.productTypeName},${e.productBrandName},${e.productName}`, 1, ['数智产品', e.productTypeName, e.productBrandName, e.productName]))
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("img", {
                  src: e.picList[0]
                }, null, 8, _hoisted_12)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(e.productName), 1),
                _createElementVNode("div", null, _toDisplayString(e.productIntroduction), 1)
              ])
            ], 8, _hoisted_10))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})